var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.5 3.21875C5.73438 3.21875 5.96875 3.45312 5.96875 3.6875C5.96875 3.95117 5.73438 4.15625 5.5 4.15625C4.44531 4.15625 3.625 5.00586 3.625 6.03125C3.625 6.29492 3.39062 6.5 3.15625 6.5C2.89258 6.5 2.6875 6.29492 2.6875 6.03125C2.6875 4.50781 3.94727 3.21875 5.5 3.21875ZM3.15625 14.3516V13.0625H7.81445V14.3516C7.81445 14.4395 7.78516 14.5273 7.75586 14.6152L7.02344 15.6699C6.93555 15.8164 6.78906 15.875 6.64258 15.875H4.32812C4.18164 15.875 4.03516 15.8164 3.94727 15.6699L3.21484 14.6152C3.15625 14.5273 3.15625 14.4395 3.15625 14.3516ZM5.5 0.875C8.3418 0.875 10.6562 3.18945 10.6562 6.03125C10.6562 7.34961 10.1582 8.52148 9.36719 9.42969C8.86914 9.98633 8.10742 11.1582 7.84375 12.125H6.4375C6.4375 11.9785 6.4375 11.8613 6.49609 11.7148C6.64258 11.1875 7.16992 9.81055 8.3125 8.52148C8.89844 7.81836 9.25 6.93945 9.25 6.03125C9.25 3.98047 7.55078 2.28125 5.5 2.28125C3.47852 2.28125 1.7207 3.89258 1.75 6.03125C1.75 6.93945 2.07227 7.81836 2.6582 8.52148C3.83008 9.83984 4.32812 11.1875 4.47461 11.7148C4.5332 11.8613 4.5332 12.0078 4.5332 12.125H3.12695C2.86328 11.1582 2.10156 9.98633 1.60352 9.42969C0.8125 8.52148 0.34375 7.34961 0.34375 6.03125C0.34375 3.30664 2.48242 0.875 5.5 0.875Z",
    fill: "#FAFAF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLight);
export default __webpack_public_path__ + "static/media/red-light.c20437876f4a4f0320c42e1e55081528.svg";
export { ForwardRef as ReactComponent };